module.exports = __webpack_public_path__ + "img/stock4.effc4aa5.png";